/**
 * @file markertype → Category re-bucketing.
 *
 * SINGLE source of truth for the new 3-category scheme. Markers, the legend
 * filter, and the results list all read `store.category` derived here — so the
 * re-bucketing lives in exactly one place and can be changed (or restored to the
 * old 5-way scheme) with a one-line edit, no CMS/data migration.
 *
 *   "4"                 -> company    (big flame; company / studio location)
 *   "3" | ""/other  -> premium    (small red flame; premium)
 *   "0" | "1" | "2"           -> dealer     (dot; distributor, dealer + certified — certified badge removed)
 */
import type { Category } from "./types";

export function toCategory(markertype: string | number | null | undefined): Category {
  const t = String(markertype ?? "").trim();
  if (t === "4") return "company";
  if (t === "2" || t === "1" || t === "0") return "dealer";
  // "3", "", and any unknown value collapse into the premium flame.
  return "premium";
}
